/* Habillage du constructeur Rapi « Créer mon pack » (section sb-pack).
   Lit l'état du constructeur Rapi (aucune remise calculée ici) et met à jour :
   paliers, compteur, cases de sélection, encart des produits offerts, choix achat unique / abonnement, bloc sous le bouton.
   Réglages : <script type="application/json" class="sbpk__config"> dans la section. */
(function () {
  var money = function (n) { return n.toFixed(2).replace('.', ',') + ' €'; };
  var num = function (el) { return el ? parseFloat(el.textContent.replace(/[^0-9,.-]/g, '').replace(',', '.')) || 0 : 0; };

  function init(root) {
    var cfg = JSON.parse(root.querySelector('.sbpk__config').textContent);
    // Rapi remplace son conteneur au montage : on le recherche à chaque mise à jour.
    var getBuilder = function () { return document.getElementById(root.dataset.builder); };
    var tiers = [].slice.call(root.querySelectorAll('.sbpk__tier'));
    var goals = tiers.map(function (t) { return Number(t.dataset.min); }).filter(function (n) { return n > 1; });
    var relais = Number(root.dataset.relais), domicile = Number(root.dataset.domicile);
    var plan = Number(root.dataset.plan || 0);
    var planPct = Number(root.dataset.planPct || 0);

    function eta() {
      var d = new Date(), n = 2 + (d.getHours() >= cfg.cutoff ? 1 : 0);
      while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) n--; }
      return d.toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' });
    }

    // Sur mobile, Rapi déplace son panier dans <body> (tiroir en bas d'écran) : on le cherche partout.
    var getPanel = function (builder) { return builder.querySelector('.rapi-bb-cart-panel') || document.querySelector('.rapi-bb-cart-panel') || builder; };

    function readCart(panel) {
      var items = [].slice.call(panel.querySelectorAll('.rapi-bb-cart-items img'));
      var countEl = panel.querySelector('.rapi-bb-cart-count');
      var rows = panel.querySelectorAll('.rapi-bb-cart-total-row');
      var final = panel.querySelector('.rapi-bb-cart-total-row--final');
      return {
        count: countEl ? parseInt(countEl.textContent, 10) || 0 : items.length,
        imgs: items.map(function (i) { return i.currentSrc || i.src; }),
        sub: num(rows[0] && rows[0].lastElementChild),
        total: num(final && final.lastElementChild)
      };
    }

    function mountSub(builder, btn) {
      var tpl = root.querySelector('.sbpk__sub-tpl');
      if (!tpl || builder.querySelector('.sbpk-sub')) return;
      var box = tpl.content.firstElementChild.cloneNode(true);
      btn.insertAdjacentElement('beforebegin', box);
      box.addEventListener('click', function (e) {
        var opt = e.target.closest('.sbpk-sub__opt');
        if (!opt) return;
        root.dataset.sub = opt.dataset.sub;
        update();
      });
    }

    function update() {
      var builder = getBuilder();
      if (!builder) return;
      var panel = getPanel(builder);
      var c = readCart(panel);
      var goal = goals.find(function (g) { return c.count < g; }) || goals[goals.length - 1];
      // Sous-titre Rapi (partagé avec le site en ligne) remplacé par un encart noir : titre + une ligne par palier (gain en jaune)
      var se = builder.querySelector('.rapi-bb-subtitle');
      if (se && !se.classList.contains('sbpk-st')) {
        var pre = se.textContent.split(':')[0].trim();
        se.innerHTML = '<span class="sbpk-st__h">' + pre + '</span>' + tiers.filter(function (t) { return t.dataset.min !== '1'; }).map(function (t) {
          return '<span class="sbpk-st__row"><b>' + t.dataset.min + ' produits</b><i>' + t.querySelector('.sbpk__off').textContent.trim() + '</i></span>';
        }).join('');
        se.classList.add('sbpk-st');
      }
      root.querySelector('.sbpk__n').textContent = c.count;
      root.querySelector('.sbpk__goal').textContent = goal;
      var reached = 0;
      tiers.forEach(function (t) { if (c.count >= Number(t.dataset.min)) reached = Number(t.dataset.min); });
      tiers.forEach(function (t) { t.classList.toggle('is-on', Number(t.dataset.min) === reached || (reached === 0 && t.dataset.min === '1')); });
      var next = tiers.filter(function (t) { return Number(t.dataset.min) > c.count && t.dataset.min !== '1'; })[0];
      // Le prochain palier se décrit par son cadeau (« 1 saucisson offert ») s'il en a un, sinon par sa remise.
      var nextLbl = next && (next.querySelector('.sbpk__note') || next.querySelector('.sbpk__off'));
      root.querySelector('.sbpk__hint').textContent = next ? cfg.hint.replace('[n]', Number(next.dataset.min) - c.count).replace('[off]', nextLbl.textContent) : cfg.max;
      // Cadeaux : débloqués selon le nombre de produits du pack (encart du haut et copie dans le panier)
      [].forEach.call(document.querySelectorAll('.sbpk-gift'), function (g) {
        var on = c.count >= Number(g.dataset.min);
        g.classList.toggle('is-on', on);
        var st = g.querySelector('.sbpk-gift__state');
        var txt = on ? cfg.giftOn : st.dataset.lock;
        if (st.textContent !== txt) st.textContent = txt;
      });
      var html = '';
      for (var i = 0; i < Math.max(goal, c.count); i++) html += c.imgs[i] ? '<span class="sbpk__slot is-full"><img src="' + c.imgs[i] + '" alt=""></span>' : '<span class="sbpk__slot">' + (i + 1) + '</span>';
      root.querySelector('.sbpk__slots').innerHTML = html;

      // Même rangée de cases dans le panier Rapi (visible tiroir fermé sur mobile, comme David).
      var head = panel.querySelector('.rapi-bb-cart-header');
      var mini = panel.querySelector('.sbpk-mini');
      if (head && !mini) {
        mini = document.createElement('div');
        mini.className = 'sbpk-mini';
        head.insertAdjacentElement('afterend', mini);
      }
      if (mini && mini.innerHTML !== html) mini.innerHTML = html;

      var btn = panel.querySelector('.rapi-bb-checkout-btn');
      if (!btn) return;
      var extra = panel.querySelector('.sbpk-extra');
      if (!extra) {
        extra = root.querySelector('.sbpk__extra-tpl').content.firstElementChild.cloneNode(true);
        btn.insertAdjacentElement('afterend', extra);
        extra.querySelector('.sbpk-extra__eta').textContent = eta();
      }
      document.body.classList.add('sbpk-on');
      // Encart cadeaux aussi dans le panier, juste au-dessus du choix achat unique / abonnement
      var gifts = root.querySelector('.sbpk-gifts');
      if (gifts && !panel.querySelector('.sbpk-gifts')) {
        var gc = gifts.cloneNode(true);
        gc.classList.add('sbpk-gifts--panel');
        btn.insertAdjacentElement('beforebegin', gc);
      }
      mountSub(panel, btn);

      // Abonnement seulement si le pack, remises comprises, atteint la livraison à domicile offerte (50 €).
      var subTotal = (c.total || c.sub) * (100 - planPct) / 100;
      var subOk = subTotal >= domicile;
      if (!subOk) root.dataset.sub = '0';
      var subOn = root.dataset.sub === '1';
      var subBox = panel.querySelector('.sbpk-sub');
      if (subBox) {
        var subOpt = subBox.querySelector('.sbpk-sub__opt[data-sub="1"]');
        if (subOpt) subOpt.disabled = !subOk;
        var lock = subBox.querySelector('.sbpk-sub__lock');
        if (!lock) {
          lock = document.createElement('p');
          lock.className = 'sbpk-sub__lock';
          lock.textContent = "L'abonnement est disponible à partir de " + money(domicile) + ' de pack (remises comprises), avec la livraison à domicile offerte.';
          subBox.appendChild(lock);
        }
        lock.hidden = subOk;
        [].forEach.call(subBox.querySelectorAll('.sbpk-sub__opt'), function (o) {
          var on = o.dataset.sub === (subOn ? '1' : '0');
          o.classList.toggle('is-on', on);
          o.setAttribute('aria-checked', on ? 'true' : 'false');
        });
        subBox.querySelector('.sbpk-sub__info').hidden = !subOn;
      }

      var total = (c.total || c.sub) * (subOn ? (100 - planPct) / 100 : 1);
      // Produits offerts débloqués : leur valeur compte dans le prix barré et dans l'économie affichée
      var giftOn = [].slice.call(root.querySelectorAll('.sbpk-gifts:not(.sbpk-gifts--panel) .sbpk-gift.is-on'));
      var giftVal = giftOn.reduce(function (s, g) { return s + num(g.querySelector('.sbpk-gift__price')); }, 0);
      var before = c.sub + giftVal;
      var saving = before - total;
      extra.querySelector('.sbpk-extra__for').textContent = cfg.total.replace('[n]', c.count) + (giftOn.length ? ' + ' + giftOn.length + ' offert' + (giftOn.length > 1 ? 's' : '') : '');
      extra.querySelector('.sbpk-extra__final').textContent = money(total);
      var orig = extra.querySelector('.sbpk-extra__orig');
      orig.hidden = !(saving > 0.004);
      orig.textContent = money(before);
      var save = extra.querySelector('.sbpk-extra__save');
      save.hidden = !(saving > 0.004);
      save.innerHTML = cfg.save.replace('[x]', '<b>' + money(saving) + '</b>');
      extra.querySelector('.sbpk-extra__fill').style.width = Math.min(100, total / domicile * 100) + '%';
      var mr = extra.querySelector('[data-at="relais"]');
      mr.style.left = (relais / domicile * 100) + '%';
      mr.classList.toggle('is-on', total >= relais);
      extra.querySelector('[data-at="domicile"]').classList.toggle('is-on', total >= domicile);
      extra.querySelector('.sbpk-extra__ship-msg').textContent = total >= domicile ? cfg.shipDone : total >= relais ? cfg.shipRelais.replace('[x]', money(domicile - total)) : cfg.shipTodo.replace('[x]', money(relais - total));
    }

    var queued = false;
    var isOwn = function (node) {
      var el = node.nodeType === 1 ? node : node.parentElement;
      return el && (root.contains(el) || !!el.closest('.sbpk-extra, .sbpk-mini, .sbpk-sub, .sbpk-gifts'));
    };
    new MutationObserver(function (list) {
      if (queued || list.every(function (m) { return isOwn(m.target); })) return;
      queued = true;
      setTimeout(function () { queued = false; update(); }, 60);
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
    update();

    // Envoi du pack au panier par Rapi : on ajoute le plan d'abonnement (si choisi) aux produits du pack,
    // et les produits offerts débloqués en lignes séparées (rendus gratuits par la remise Shopify « achetez X, obtenez Y »).
    var giftList = [].slice.call(root.querySelectorAll('.sbpk-gifts .sbpk-gift')).map(function (g) { return { min: Number(g.dataset.min), id: Number(g.dataset.variant) }; });
    var lastGift = 0;
    var unlocked = function () {
      var b = getBuilder();
      if (!b) return [];
      var n = readCart(getPanel(b)).count;
      return giftList.filter(function (g) { return g.id && n >= g.min; });
    };
    // Rapi envoie le panier soit en JSON, soit en formulaire jQuery (items[0][properties][_rapi_box_builder]=…).
    var rewrite = function (body) {
      var sub = plan && root.dataset.sub === '1';
      var gifts = Date.now() - lastGift < 4000 ? [] : unlocked(); // une seule fois par envoi du pack
      if (!sub && !gifts.length) return body;
      try {
        var data = JSON.parse(body);
        var isPack = false;
        (data.items || []).forEach(function (item) {
          if (item.properties && item.properties._rapi_box_builder) { isPack = true; if (sub) item.selling_plan = plan; }
        });
        if (!isPack) return body;
        if (gifts.length) {
          lastGift = Date.now();
          gifts.forEach(function (g) { data.items.push({ id: g.id, quantity: 1, properties: { Cadeau: cfg.giftProp } }); });
        }
        return JSON.stringify(data);
      } catch (err) {
        var params = new URLSearchParams(body);
        var lines = [];
        var last = -1;
        params.forEach(function (value, key) {
          var i = key.match(/^items\[(\d+)\]/);
          if (i) last = Math.max(last, Number(i[1]));
          var m = key.match(/^items\[(\d+)\]\[properties\]\[_rapi_box_builder\]$/);
          if (m) lines.push(m[1]);
        });
        if (!lines.length) return body;
        if (sub) lines.forEach(function (i) { params.set('items[' + i + '][selling_plan]', plan); });
        if (gifts.length) {
          lastGift = Date.now();
          gifts.forEach(function (g) {
            last++;
            params.set('items[' + last + '][id]', g.id);
            params.set('items[' + last + '][quantity]', 1);
            params.set('items[' + last + '][properties][Cadeau]', cfg.giftProp);
          });
        }
        return params.toString();
      }
    };
    if (plan || giftList.length) {
      var isAdd = function (url) { return /\/cart\/add(\.js)?(\?|$)/.test(url || ''); };
      var nativeFetch = window.fetch;
      window.fetch = function (input, opts) {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (isAdd(url) && opts && typeof opts.body === 'string') {
          opts = Object.assign({}, opts, { body: rewrite(opts.body) });
        }
        return nativeFetch.call(this, input, opts);
      };
      var nativeOpen = XMLHttpRequest.prototype.open, nativeSend = XMLHttpRequest.prototype.send;
      XMLHttpRequest.prototype.open = function (method, url) { this._sbpkUrl = url; return nativeOpen.apply(this, arguments); };
      XMLHttpRequest.prototype.send = function (body) {
        if (isAdd(this._sbpkUrl) && typeof body === 'string') body = rewrite(body);
        return nativeSend.call(this, body);
      };
    }

    var pick = root.querySelector('.sbpk__pick');
    if (pick) pick.addEventListener('click', function () {
      var builder = getBuilder();
      if (!builder) return;
      var cards = [].slice.call(builder.querySelectorAll('.rapi-bb-card'));
      var queue = cfg.picks.map(function (title) {
        return cards.find(function (card) { var t = card.querySelector('.rapi-bb-card__title'); return t && t.textContent.trim() === title.trim(); });
      }).filter(function (card) { return card && !card.querySelector('.rapi-bb-card__qty'); });
      (function next() {
        var card = queue.shift();
        if (!card) { builder.scrollIntoView({ behavior: 'smooth', block: 'start' }); return; }
        var b = card.querySelector('.rapi-bb-card__cta');
        if (b) b.click();
        setTimeout(next, 220);
      })();
    });
  }

  function start() { [].forEach.call(document.querySelectorAll('.sbpk'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
